import React, { useMemo } from "react";

import "./NormalizersOptions.scss";

export const NormalizersOptions = ({ options }) => {
    const optionsData = useMemo(()=>(
        options ? JSON.parse(options) : null
    ),[ options ]);

    return (
        <div className={"normalizers-options"}>
            {
                optionsData.map(({ key, value })=>(
                    <div key={value + key}>
                        <b>{key}</b>:&nbsp;<span className={"normalizers-options__item"}>{value}</span>
                    </div>
                ))
            }
        </div>
    );
};
